module.exports = __webpack_public_path__ + "static/media/writing.fa8b9298.jpg";